/* eslint-disable require-jsdoc */
import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for SOS authentication and authorization
 */
export const AuthContext = createContext();

/**
 * Hook to use SOS auth context
 * @return {Object} Auth context value
 */
export const useAuth = () => useContext(AuthContext);

/**
 * SOS Auth Provider component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @param {Array<Object>} props.menus - Menu items
 * @param {Array<Object>} props.featureList - Feature permissions list
 * @return {JSX.Element} Auth provider component
 */
export const SosAuthProvider = ({ children, menus, featureList }) => {
  const [authorizationContext, setAuthorizationContext] = useState(null);
  const [featureListContext, setfeatureListContext] = useState(null);

  useEffect(() => {
    if (menus) {
      setAuthorizationContext({ menus: menus });
    }
    if (featureList) {
      setfeatureListContext({ featureList: featureList });
    }
  }, [menus, featureList]);

  return (
    <AuthContext.Provider
      value={{
        authorizationContext,
        setAuthorizationContext,
        featureListContext,
        setfeatureListContext,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

SosAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  menus: PropTypes.arrayOf(PropTypes.object),
  featureList: PropTypes.arrayOf(PropTypes.object),
};
